import { getTherapistsAnalyticsById } from './getTherapistsAnalyticsById';

export interface IMyZone {
  getTherapistsAnalyticsById: typeof getTherapistsAnalyticsById;
}

/**
 * @namespace
 */
const MyZone: IMyZone = {
  getTherapistsAnalyticsById,
};

export default MyZone;
export * from './types';
